export default function profileReducer(draft, action) {

   switch (action.type) {
    case 'YEAR_CALC_SWITCH': {
      const result = draft.find(({ name }) => name === action.name);
      result.yearCalc = !result.yearCalc;
      break;
    }
    case 'UPDATE_NAME': {
      const result = draft.find(({ name }) => name === action.name);
      result.name = action.newName;
      break;
    }
    case 'CREATE': {
      const profile = {
        id: "",
        name: action.name,
        income: action.income,
        expenses: action.expenses,
        debt: action.debt,
        yearCalc: action.yearCalc
      }
      const result = draft.findIndex(({ name }) => name === action.name);
      if (result === -1) {
        draft.push(profile);
      } else {
        alert("Profile already exists");
      }
      break;
    }
    case 'CLEAR': {
      draft = action.initialProfiles;
      break;
    }
    case 'SAVE': {
      const result = draft.findIndex(({ name }) => name === action.profile.name);
      if (result === -1) {
        draft.push(action.profile);
      } else {
        draft.splice(result, 1, action.profile);
      }
      break;
    }
    case 'REMOVE': {
      const result = draft.findIndex(({ name }) => name === action.profile.name);
      if (result !== -1) {
        draft.splice(result, 1);
      }
      break;
    }
    case 'SAVE_ALL': {
      draft = action.profiles;
      break;
    }
    default: console.log("No Action");
  }
  return draft;
}